module.exports = "<div\n  data-angular-treeview=\"true\"\n  data-tree-id=\"abc\"\n  data-tree-model=\"$ctrl.networks\"\n  data-node-id=\"id\"\n  data-node-label=\"name\"\n  data-node-children=\"accounts\" >\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/cn/cntree.html
// module id = 37
// module chunks = 0